"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _incontentmessage_styles = _interopRequireDefault(require("./incontentmessage_styles"));

var _incontentmessage_definition = _interopRequireDefault(require("./incontentmessage_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : INCONTENT MESSAGE ~~~~~~~~~~ ========== */


var InContentMessage = (0, _reactJss.default)(_incontentmessage_styles.default)(function (props) {
  var hasMessage = function hasMessage() {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = props.inContentMessages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var message = _step.value;

        if (!(0, _index2.hasLocalStorage)(message.name) && message.enabled !== false && message.pages.filter(function (url) {
          return props.currentPage.startsWith(url);
        }).length > 0 && message.pagesExcluded.filter(function (url) {
          return props.currentPage.startsWith(url);
        }).length === 0) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  };

  var getMessagesForPage = function getMessagesForPage() {
    return props.inContentMessages.map(function (currentMessage, index) {
      if (!(0, _index2.hasLocalStorage)(currentMessage.name) && currentMessage.enabled !== false && currentMessage.pages.filter(function (url) {
        return props.currentPage.startsWith(url);
      }).length > 0 && currentMessage.pagesExcluded.filter(function (url) {
        return props.currentPage.startsWith(url);
      }).length === 0) {
        return _react.default.createElement(_index.InlineMessage, {
          key: index,
          display: currentMessage.enabled,
          name: currentMessage.name,
          variant: currentMessage.variant,
          icon: currentMessage.icon,
          title: currentMessage.title,
          message: currentMessage.message,
          close: currentMessage.close,
          handleClose: currentMessage.handleClose
        });
      }
    });
  };

  return !hasMessage() ? null : _react.default.createElement("div", {
    className: "message incontentmessage ".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.incontentmessage)
  }, getMessagesForPage());
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(InContentMessage, _incontentmessage_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = InContentMessage;
exports.default = _default;